import { createRestClient } from '@monorepo/rest-client';

// CRA thay process.env.* thành chuỗi cố định lúc build, nên thiếu biến này thì baseURL là undefined và
// axios gửi request tương đối — dev server trả về index.html kèm status 200, hỏng ở tận tầng mapper.
// Báo ngay từ đây để lỗi cấu hình env lộ ra đúng chỗ.
if (!process.env.REACT_APP_BASE_REST_URL) {
  throw new Error('Thiếu REACT_APP_BASE_REST_URL — xem apps/customer-service/.env.dev');
}

export const restClient = createRestClient({ baseURL: process.env.REACT_APP_BASE_REST_URL });
